/** @jsx jsx */
import {useEffect, useState} from 'react'
import {PropTypes} from 'prop-types'
import {jsx, css} from '@emotion/react'
import {Link} from 'gatsby'
import Layout from '../../../layout'
import SEO from '../../../seo'
import SurveyUninstall from '../../../uninstall/survey-uninstall'
import {logDplWithExtensionParams, EVENTS} from '../../../../util/dpl'
import {legacyExtensionFavicons} from '../../../../constants'
import Footer from '../footer'
import StartpageLogoNew from '../../../../images/4624/startpage-logo.svg'
import Button from '../button'

const Uninstall4624 = ({languageCode = 'en'}) => {
    const translations = {
        en: {
            title: 'You’ve uninstalled the Startpage private search extension.',
            description: 'We are sorry to see you go, please help us improve',
            buttonText: 'Re-install extension',
        },
        de: {
            title: 'Die Startpage Datenschutz-Suchmaschine wurde deinstalliert.',
            description: 'Bitte hilf uns, unsere Erweiterung zu verbessern.',
            buttonText: 'Erweiterung wieder installieren',
        },
        nl: {
            title: 'De Startpage privacy-search-extensie is verwijderd.',
            description: 'Help ons onze extensie te verbeteren.',
            buttonText: 'Extensie opnieuw installeren',
        },
        fr: {
            title: 'La protection de confidentialité de Startpage a été désinstallée.',
            description: 'Aidez-nous à améliorer notre extension.',
            buttonText: 'Réinstaller l’extension',
        },
    }

    const text = translations[languageCode]

    const [hasFiredUinstall, setHasFiredUinstall] = useState(false)

    useEffect(() => {
        if (!hasFiredUinstall) {
            logDplWithExtensionParams(
                EVENTS.StartpagePageLoad, // event
            )
            setHasFiredUinstall(true)
        }
    }, [hasFiredUinstall])

    return (
        <Layout>
            <SEO
                title={text.title}
                description={text.description}
                favicons={legacyExtensionFavicons}
                ogImagePath="https://www.startpage.com/sp/cdn/favicons/extension/sp_icon_128.png"
            />
            <div className="wrapper">
                <section
                    className="hero"
                    css={css`
                        background: linear-gradient(248deg, #f0f3ff 20.14%, #fcf3ff 80.89%);
                        padding: 2rem 1rem 4rem;
                        text-align: center;
                    `}
                >
                    <div
                        className="header"
                        css={css`
                            padding: 10px 1rem 50px;
                        `}
                    >
                        <div
                            className="container"
                            css={css`
                                max-width: 1150px;
                                margin: 0 auto;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                            `}
                        >
                            <a
                                href={`https://www.startpage.com${
                                    typeof window !== 'undefined' && window.location.href.match('/de') ? '/de' : ''
                                }`}
                                rel="noopener noreferrer"
                            >
                                <StartpageLogoNew
                                    alt="home"
                                    css={css`
                                        width: 192px;
                                    `}
                                />
                            </a>
                            <Link to="/">
                                <Button
                                    text={text.buttonText}
                                    languageCode={languageCode}
                                    onClick={(e) => {
                                        window.location.href = '/'
                                    }}
                                />
                            </Link>
                        </div>
                    </div>
                    <h2
                        css={css`
                            font-size: 2.3125rem;
                            margin-bottom: 1rem;
                            font-weight: 800;
                            font-size: 40px;
                            letter-spacing: 0.33px;
                            max-width: 800px;
                            margin: 0 auto 20px;
                        `}
                    >
                        {text.title}
                    </h2>
                    <p>{text.description}</p>
                </section>
                <section
                    className="main"
                    css={css`
                        position: relative;
                        padding: 4rem 4rem 8rem 4rem;
                        @media (max-width: 600px) {
                            padding: 3rem 1.5rem 3rem 1.5rem;
                        }
                    `}
                >
                    <div
                        css={css`
                            z-index: 2;
                            position: relative;
                        `}
                    >
                        <SurveyUninstall languageCode={languageCode} />
                    </div>
                </section>
            </div>
            <Footer />
        </Layout>
    )
}

Uninstall4624.propTypes = {
    languageCode: PropTypes.string,
}

Uninstall4624.defaultProps = {
    languageCode: `en`,
}

export default Uninstall4624
